import { render, staticRenderFns } from "./PxAssetsTable.vue?vue&type=template&id=6f94cbd2&scoped=true&"
import script from "./PxAssetsTable.vue?vue&type=script&lang=js&"
export * from "./PxAssetsTable.vue?vue&type=script&lang=js&"
import style0 from "./PxAssetsTable.vue?vue&type=style&index=0&id=6f94cbd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f94cbd2",
  null
  
)

export default component.exports